/**
 * Built-in FlashBook HTML themes — served as static assets from
 * /public/themes/flashbook/. These are FlashBook-specific and intentionally
 * separate from the capsule HTML theme list (src/lib/htmlThemes.ts).
 *
 * To add a new FlashBook HTML theme:
 *  1. Drop the .html file in public/themes/flashbook/ (bridge protocol v4:
 *     host→iframe `page_show {index, page, total}`, iframe→host
 *     `block_answer {pageId, blockId, value, timeSpentMs}`, see
 *     docs/flashbook-html-theme.md).
 *  2. Add an entry below.
 */
export interface BuiltinFlashbookHtmlTheme {
  id: string
  name: string
  emoji: string
  path: string
  category: string
}

export const BUILTIN_FLASHBOOK_HTML_THEMES: readonly BuiltinFlashbookHtmlTheme[] =
  [
    {
      id: 'magic-book',
      name: 'Magic Book',
      emoji: '📖',
      path: '/themes/flashbook/magic-book.html',
      category: 'classic',
    },
    {
      id: 'galaxy-reader',
      name: 'Galaxy Reader',
      emoji: '🌌',
      path: '/themes/flashbook/galaxy-reader.html',
      category: 'missions',
    },
  ]